import React, { FC } from 'react';
import { Button, ButtonProps } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { Template } from '@common/types';
import { ExternalLink } from '@wix/wix-ui-icons-common';

type ViewTemplateButtonProps = {
  buttonSize: ButtonProps['size'];
  viewTemplatePath: string;
  template: Template;
  entry?: string | null;
  logBiClick: ({ clickType }: { clickType: string }) => void;
};

const ViewTemplateButton: FC<ViewTemplateButtonProps> = ({
  buttonSize,
  viewTemplatePath,
  template,
  entry,
  logBiClick,
}) => {
  const { t } = useTranslation();
  return (
    <Button
      dataHook="view-template-cta"
      size={buttonSize}
      skin="dark"
      priority="secondary"
      as="a"
      href={`${viewTemplatePath}/${template.id}${
        entry ? `?entry=${entry}` : ''
      }`}
      target="_blank"
      onClick={() => {
        logBiClick({ clickType: 'View Template' });
      }}
      suffixIcon={<ExternalLink />}
    >
      {t('marketplace.templates-page.view-template-cta')}
    </Button>
  );
};

export default ViewTemplateButton;
